"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Permissions = exports.PermissionDescriptions = exports.InheritedPermissions = exports.EmployeeOnlyPermissions = exports.DefaultPermissions = void 0;
/** AUTOMATICALLY GENERATED BY Permissions.java. DO NOT EDIT!! **/

var Permissions = exports.Permissions = {
  CHECK_IN: 0,
  VIEW_DATABASE: 1,
  EDIT_MEMBER_IMAGES: 2,
  EDIT_GUEST_PASSES: 3,
  EDIT_DATABASE: 4,
  BULK_OPERATION: 5,
  TRIGGER_PASS_PRINTING: 6,
  MARKETPLACE_PURCHASE: 7,
  MARKETPLACE_REDEEM: 8,
  SIMPLE_MARKETPLACE_MANAGE: 10,
  MARKETPLACE_REFUNDS: 11,
  FULL_MARKETPLACE_CONTROL: 12,
  VIEW_INVOICES: 13,
  MANAGE_INVOICES: 14,
  ISSUE_INVOICES: 15,
  PROCESS_APPLICATIONS: 24,
  REFUND_APPLICATIONS: 25,
  MANAGE_APPLICATION_SETTINGS: 26,
  VIEW_PASSES: 32,
  MANAGE_PASSES: 33,
  VIEW_BOOKING: 36,
  MANAGE_EVENTS: 37,
  MANAGE_RESOURCES: 41,
  VIEW_ACCOUNT_PORTAL: 42,
  MANAGE_ACCOUNT: 43,
  PRINT: 48,
  BULK_MAIL: 49,
  TRIGGER_FREE_PASS_PRINTING: 50,
  ADMINISTER_PASSES: 53,
  SUBMIT_PAPER_APPLICATIONS: 54,
  ADMINISTER_APPLICATIONS: 55,
  ADMINISTER_ACCOUNTS: 56,
  CREATE_USERS: 57,
  CREATE_DATABASES: 58,
  POST_CHECK_PAYMENTS: 59,
  DEVELOP: 62
};

//Inherited Permissions for each Permission
var InheritedPermissions = exports.InheritedPermissions = {
  CHECK_IN: [],
  VIEW_DATABASE: [],
  EDIT_MEMBER_IMAGES: ["VIEW_DATABASE"],
  EDIT_GUEST_PASSES: ["VIEW_DATABASE"],
  EDIT_DATABASE: ["VIEW_DATABASE", "EDIT_MEMBER_IMAGES", "EDIT_GUEST_PASSES"],
  BULK_OPERATION: ["EDIT_DATABASE", "VIEW_DATABASE", "EDIT_MEMBER_IMAGES", "EDIT_GUEST_PASSES"],
  TRIGGER_PASS_PRINTING: ["VIEW_DATABASE"],
  MARKETPLACE_PURCHASE: ["VIEW_DATABASE"],
  MARKETPLACE_REDEEM: ["VIEW_DATABASE"],
  SIMPLE_MARKETPLACE_MANAGE: ["VIEW_DATABASE", "MARKETPLACE_PURCHASE", "MARKETPLACE_REDEEM"],
  MARKETPLACE_REFUNDS: ["SIMPLE_MARKETPLACE_MANAGE", "VIEW_DATABASE", "MARKETPLACE_PURCHASE", "MARKETPLACE_REDEEM"],
  FULL_MARKETPLACE_CONTROL: ["MARKETPLACE_REFUNDS", "SIMPLE_MARKETPLACE_MANAGE", "VIEW_DATABASE", "MARKETPLACE_PURCHASE", "MARKETPLACE_REDEEM"],
  VIEW_INVOICES: ["VIEW_DATABASE"],
  MANAGE_INVOICES: ["VIEW_INVOICES", "VIEW_DATABASE"],
  ISSUE_INVOICES: ["MANAGE_INVOICES", "VIEW_INVOICES", "VIEW_DATABASE"],
  PROCESS_APPLICATIONS: [],
  REFUND_APPLICATIONS: ["PROCESS_APPLICATIONS"],
  MANAGE_APPLICATION_SETTINGS: ["PROCESS_APPLICATIONS"],
  VIEW_PASSES: [],
  MANAGE_PASSES: ["VIEW_PASSES"],
  VIEW_BOOKING: [],
  MANAGE_EVENTS: ["VIEW_BOOKING"],
  MANAGE_RESOURCES: ["VIEW_BOOKING", "MANAGE_EVENTS"],
  VIEW_ACCOUNT_PORTAL: [],
  MANAGE_ACCOUNT: [],
  PRINT: ["VIEW_PASSES"],
  BULK_MAIL: ["PRINT", "VIEW_PASSES"],
  TRIGGER_FREE_PASS_PRINTING: ["TRIGGER_PASS_PRINTING", "VIEW_DATABASE"],
  ADMINISTER_PASSES: ["MANAGE_PASSES", "VIEW_PASSES"],
  SUBMIT_PAPER_APPLICATIONS: [],
  ADMINISTER_APPLICATIONS: [],
  ADMINISTER_ACCOUNTS: ["VIEW_ACCOUNT_PORTAL"],
  CREATE_USERS: [],
  CREATE_DATABASES: ["MANAGE_ACCOUNT"],
  POST_CHECK_PAYMENTS: ["VIEW_ACCOUNT_PORTAL"],
  DEVELOP: []
};

//Default Permissions for each Role
var DefaultPermissions = exports.DefaultPermissions = {
  SUPERADMIN: ["CHECK_IN", "VIEW_DATABASE", "EDIT_MEMBER_IMAGES", "EDIT_GUEST_PASSES", "EDIT_DATABASE", "BULK_OPERATION", "TRIGGER_PASS_PRINTING", "MARKETPLACE_PURCHASE", "MARKETPLACE_REDEEM", "SIMPLE_MARKETPLACE_MANAGE", "MARKETPLACE_REFUNDS", "FULL_MARKETPLACE_CONTROL", "VIEW_INVOICES", "MANAGE_INVOICES", "ISSUE_INVOICES", "PROCESS_APPLICATIONS", "REFUND_APPLICATIONS", "MANAGE_APPLICATION_SETTINGS", "VIEW_PASSES", "MANAGE_PASSES", "VIEW_BOOKING", "MANAGE_EVENTS", "MANAGE_RESOURCES", "VIEW_ACCOUNT_PORTAL", "MANAGE_ACCOUNT", "PRINT", "BULK_MAIL", "TRIGGER_FREE_PASS_PRINTING", "ADMINISTER_PASSES", "SUBMIT_PAPER_APPLICATIONS", "ADMINISTER_APPLICATIONS", "ADMINISTER_ACCOUNTS", "CREATE_USERS", "CREATE_DATABASES", "POST_CHECK_PAYMENTS", "DEVELOP"],
  AGENT: ["CHECK_IN", "VIEW_DATABASE", "EDIT_MEMBER_IMAGES", "EDIT_GUEST_PASSES", "EDIT_DATABASE", "BULK_OPERATION", "TRIGGER_PASS_PRINTING", "MARKETPLACE_PURCHASE", "MARKETPLACE_REDEEM", "SIMPLE_MARKETPLACE_MANAGE", "MARKETPLACE_REFUNDS", "FULL_MARKETPLACE_CONTROL", "VIEW_INVOICES", "MANAGE_INVOICES", "ISSUE_INVOICES", "PROCESS_APPLICATIONS", "REFUND_APPLICATIONS", "MANAGE_APPLICATION_SETTINGS", "VIEW_PASSES", "MANAGE_PASSES", "VIEW_BOOKING", "MANAGE_EVENTS", "MANAGE_RESOURCES", "VIEW_ACCOUNT_PORTAL", "MANAGE_ACCOUNT", "PRINT", "BULK_MAIL", "TRIGGER_FREE_PASS_PRINTING", "ADMINISTER_PASSES", "SUBMIT_PAPER_APPLICATIONS", "ADMINISTER_APPLICATIONS", "POST_CHECK_PAYMENTS"],
  EMPLOYEE: ["VIEW_DATABASE", "EDIT_MEMBER_IMAGES", "EDIT_GUEST_PASSES", "EDIT_DATABASE", "TRIGGER_PASS_PRINTING", "PROCESS_APPLICATIONS", "REFUND_APPLICATIONS", "PRINT", "TRIGGER_FREE_PASS_PRINTING"],
  ADMIN: ["CHECK_IN", "VIEW_DATABASE", "EDIT_MEMBER_IMAGES", "EDIT_GUEST_PASSES", "EDIT_DATABASE", "BULK_OPERATION", "TRIGGER_PASS_PRINTING", "MARKETPLACE_PURCHASE", "MARKETPLACE_REDEEM", "SIMPLE_MARKETPLACE_MANAGE", "MARKETPLACE_REFUNDS", "FULL_MARKETPLACE_CONTROL", "VIEW_INVOICES", "MANAGE_INVOICES", "ISSUE_INVOICES", "PROCESS_APPLICATIONS", "REFUND_APPLICATIONS", "MANAGE_APPLICATION_SETTINGS", "VIEW_PASSES", "MANAGE_PASSES", "VIEW_BOOKING", "MANAGE_EVENTS", "MANAGE_RESOURCES", "VIEW_ACCOUNT_PORTAL", "MANAGE_ACCOUNT"],
  MANAGER: ["CHECK_IN", "VIEW_DATABASE", "EDIT_MEMBER_IMAGES", "EDIT_GUEST_PASSES", "EDIT_DATABASE", "BULK_OPERATION", "TRIGGER_PASS_PRINTING", "MARKETPLACE_PURCHASE", "MARKETPLACE_REDEEM", "SIMPLE_MARKETPLACE_MANAGE", "PROCESS_APPLICATIONS", "VIEW_BOOKING"],
  ATTENDANT: ["CHECK_IN", "VIEW_DATABASE", "MARKETPLACE_PURCHASE", "MARKETPLACE_REDEEM", "VIEW_BOOKING"],
  KIOSK: ["CHECK_IN"],
  OBSERVER: ["VIEW_DATABASE"]
};

//Employee only permissions
var EmployeeOnlyPermissions = exports.EmployeeOnlyPermissions = ["PRINT", "BULK_MAIL", "TRIGGER_FREE_PASS_PRINTING", "ADMINISTER_PASSES", "SUBMIT_PAPER_APPLICATIONS", "ADMINISTER_APPLICATIONS", "ADMINISTER_ACCOUNTS", "CREATE_USERS", "CREATE_DATABASES", "POST_CHECK_PAYMENTS", "DEVELOP"];

//Permission Descriptions/Tooltips
var PermissionDescriptions = exports.PermissionDescriptions = {
  CHECK_IN: "User can check in/out Members and guests, and adjust the occupancy",
  VIEW_DATABASE: "User can view Member details, Logs, and Statistics",
  EDIT_MEMBER_IMAGES: "User can edit Member images",
  EDIT_GUEST_PASSES: "User can modify Membership virtual guest passes",
  EDIT_DATABASE: "User can add, edit, and delete Memberships and Members",
  BULK_OPERATION: "User can apply bulk operations to multiple Memberships/Members",
  TRIGGER_PASS_PRINTING: "User can trigger passes to be printed and mailed",
  MARKETPLACE_PURCHASE: "User can operate the Marketplace for product purchases",
  MARKETPLACE_REDEEM: "User can redeem items on a ticket in the Marketplace",
  SIMPLE_MARKETPLACE_MANAGE: "User can view the Marketplace transactions, tickets, and analysis, and email/print tickets for patrons",
  MARKETPLACE_REFUNDS: "User can refund product purchases and deposits on tickets in the Marketplace",
  FULL_MARKETPLACE_CONTROL: "User can fully manage the products, tickets, and all other aspects of the Marketplace",
  VIEW_INVOICES: "User can view Invoice Requests, Invoices, and Billing Analysis",
  MANAGE_INVOICES: "User can void Invoices, mark them as paid, and email reminders",
  ISSUE_INVOICES: "User can manage and create new Invoice Requests",
  PROCESS_APPLICATIONS: "User can process Applications",
  REFUND_APPLICATIONS: "User can refund payment on an Application",
  MANAGE_APPLICATION_SETTINGS: "User can manage most application settings for the community",
  VIEW_PASSES: "User can view but not change anything in the Pass Printing portal",
  MANAGE_PASSES: "User can manage pass printing and modify paper and ePass designs",
  VIEW_BOOKING: "User can view but not change anything in the Booking portal",
  MANAGE_EVENTS: "User can create and manage events on Resources",
  MANAGE_RESOURCES: "User can manage all Resources and Services",
  VIEW_ACCOUNT_PORTAL: "User can view the community financial data",
  MANAGE_ACCOUNT: "User can manage the community account and financial settings",
  PRINT: "Employee can print passes",
  BULK_MAIL: "Employee can bulk mail and receives credit for it",
  TRIGGER_FREE_PASS_PRINTING: "Employee can trigger pass printing and not have the client be charged",
  ADMINISTER_PASSES: "Employee can add and delete Communities from the Pass Portal",
  SUBMIT_PAPER_APPLICATIONS: "Employee can enter a paper application on behalf of a Patron",
  ADMINISTER_APPLICATIONS: "Employee can control Application Portal community settings and edit Templates",
  ADMINISTER_ACCOUNTS: "Employee can administer client Accounts",
  CREATE_USERS: "Employee can create/edit/delete non-employee users",
  CREATE_DATABASES: "Employee can create/edit databases",
  POST_CHECK_PAYMENTS: "Employee can process received checks",
  DEVELOP: "Employee is a software developer/tester"
};